import { render, staticRenderFns } from "./KeywordsLimitManagement.vue?vue&type=template&id=4440728e&scoped=true&"
import script from "./KeywordsLimitManagement.vue?vue&type=script&lang=js&"
export * from "./KeywordsLimitManagement.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsLimitManagement.vue?vue&type=style&index=0&id=4440728e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4440728e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
